/**
 * ui/storyboard-project-actions.js
 * Quản lý các thao tác xuất / nhập dự án (Lưu file, Mở file, Chia sẻ liên kết URL, Khởi tạo thú cưng dự án).
 */

import { BlockyAnimal } from '../../avatars/blocky-animal.js';
import { defaultSfx } from '../../audio/sfx.js';
import { startVideoRecording, showToastNotification } from '../recording.js';

export function clearProjectPets(state) {
  if (Array.isArray(state.projectPets)) {
    state.projectPets.forEach((pet) => {
      if (pet.root?.parent) pet.root.parent.remove(pet.root);
      else if (state.scene && pet.root) state.scene.remove(pet.root);
      if (typeof pet.dispose === 'function') pet.dispose();
      if (Array.isArray(state.activeAvatars)) {
        const idx = state.activeAvatars.indexOf(pet);
        if (idx !== -1) state.activeAvatars.splice(idx, 1);
      }
    });
  }
  state.projectPets = [];
}

export function spawnProjectPets(pets, state) {
  clearProjectPets(state);
  if (!Array.isArray(pets)) return;

  pets.forEach((petCfg, i) => {
    const species = petCfg.species || 'DOG';
    const variant = petCfg.variant || 'shiba';
    const s = Number(petCfg.scale);
    const scale = Number.isFinite(s) && s > 0 ? s : 1.0;
    const pet = new BlockyAnimal(species, variant, { scale });
    pet.root.name = `Animal_${species}_${i}`;

    const px = petCfg.position?.x ?? 1.6 + i * 1.0;
    const py = petCfg.position?.y ?? 0;
    const pz = petCfg.position?.z ?? 0.3;
    pet.root.position.set(px, py, pz);
    if (petCfg.rotation?.y !== undefined) {
      pet.root.rotation.y = petCfg.rotation.y;
    }
    pet.playAction(petCfg.action || 'idle');
    if (state.scene) state.scene.add(pet.root);
    if (Array.isArray(state.activeAvatars)) state.activeAvatars.push(pet);
    state.projectPets.push(pet);
  });
}

export function initProjectActionListeners(state, handlers = {}, helpers = {}) {
  const { characterManager, projectManager } = state;
  const { loadAndApplyProject } = helpers;

  document.getElementById('btn-project-save')?.addEventListener('click', async () => {
    const titleIn = document.getElementById('input-project-title');
    if (titleIn && titleIn.value.trim()) {
      state.currentProject.title = titleIn.value.trim();
    }
    state.currentProject.characters = characterManager.getAllCharacters().filter((c) => !c.isBuiltIn);
    const res = await projectManager.saveProjectToFile(state.currentProject);
    if (res.success) {
      defaultSfx.playTactileFeedback(680);
      alert(`Đã lưu dự án thành công: ${res.fileName}`);
    } else if (!res.aborted) {
      alert(`Lỗi khi lưu dự án: ${res.error || 'Thao tác bị hủy'}`);
    }
  });

  document.getElementById('btn-project-open')?.addEventListener('click', async () => {
    const res = await projectManager.openProjectFromFile();
    if (res.success && res.project) {
      if (typeof loadAndApplyProject === 'function') {
        loadAndApplyProject(res.project, res.fileName);
      }
      defaultSfx.playTactileFeedback(640);
      showToastNotification(`📂 Đã nạp dự án "${state.currentProject.title || res.fileName}" thành công!`);
    }
  });

  document.getElementById('btn-project-share-url')?.addEventListener('click', async () => {
    const titleIn = document.getElementById('input-project-title');
    if (titleIn && titleIn.value.trim()) {
      state.currentProject.title = titleIn.value.trim();
    }
    state.currentProject.characters = characterManager.getAllCharacters().filter((c) => !c.isBuiltIn);
    const shareUrl = projectManager.encodeProjectToUrl(state.currentProject);
    try {
      await navigator.clipboard.writeText(shareUrl);
      showToastNotification('🔗 Đã sao chép link kịch bản vào clipboard!');
    } catch {
      prompt('Sao chép liên kết kịch bản dưới đây:', shareUrl);
    }
    defaultSfx.playTactileFeedback(640);
  });

  document.getElementById('btn-project-export-video')?.addEventListener('click', () => {
    startVideoRecording(state, handlers.switchMode);
  });
}
